import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Field } from "@cotecna/dynamic-view-engine";
import { AdditionalFieldControlType } from "src/app/settings/models/preset";
@Component({
    selector: "additional-info-input",
    templateUrl: "./additional-info-input.component.html",
    styleUrls: ["./additional-info-input.component.scss"],
    standalone: false
})
export class AdditionalInfoInputComponent {
  @Input()
  public field: Field;

  @Input()
  public controlType: AdditionalFieldControlType;

  @Input()
  public mandatory: boolean;

  @Output()
  public edit: EventEmitter<{
    field: Field;
    controlType: AdditionalFieldControlType;
  }> = new EventEmitter<{
    field: Field;
    controlType: AdditionalFieldControlType;
  }>();

  @Output()
  public remove: EventEmitter<Field> = new EventEmitter<Field>();

  @Output()
  public update: EventEmitter<{
    field: Field;
    controlType: AdditionalFieldControlType;
  }> = new EventEmitter<{
    field: Field;
    controlType: AdditionalFieldControlType;
  }>();

  public constructor() {}

  public onChange(value: string): void {
    this.field.value = value.trim();
    this.update.emit({ field: this.field, controlType: this.controlType });
  }

  public onEdit() {
    this.edit.emit({ field: this.field, controlType: this.controlType });
  }

  public onRemove() {
    this.remove.emit(this.field);
  }

  public selectValue(event: any): void {
    this.field.value = event.value;
    this.update.emit({ field: this.field, controlType: this.controlType });
  }

  public onMenuClick(event: Event): void {
    event.stopPropagation();
  }
}
